import * as d3 from 'd3'
import { pointer } from 'd3-selection'
// import { legend } from "@d3/color-legend"

const DEFAULT_OPTS = {
  width: 400,
  height: 300,
  margin: { top: 20, right: 30, bottom: 30, left: 50 },
  colors: d3.schemeTableau10,
  fillOpacity: 0.2,
}

const mergeDatasets = (datasets) => {
  return datasets.reduce((a, b) => a.concat(b.data), [])
}

class LineChart {
  constructor(svg, datasets = [], opts = {}) {
    const { width, height, margin, colors, fillOpacity } = Object.assign({}, DEFAULT_OPTS, opts)

    this.svgElement = svg
    this.svg = d3.select(svg)
    this.margin = margin
    this.colorsRange = colors
    this.fillOpacity = fillOpacity

    this.setSize(width, height)

    this.datasets = datasets

    this.build()
  }

  // series() {
  //   return d3.stack().keys(this.datasets.columns.slice(1))(this.datasets)
  // }

  x() {
    return d3.scaleUtc()
      // .domain(d3.extent(this.datasets, d => d.date))
      .domain(d3.extent(mergeDatasets(this.datasets), d => d.date))
      .range([this.margin.left, this.width - this.margin.right])
  }

  xAxis(g) {
    return g
      .attr("transform", `translate(0,${this.height - this.margin.bottom})`)
      .call(d3.axisBottom(this.x()).ticks(this.width / 80).tickSizeOuter(0))
  }

  y() {
    return d3.scaleLinear()
      // .domain([0, d3.max(this.data, d => d.value)]).nice()
      .domain([0, d3.max(mergeDatasets(this.datasets), d => d.value)]).nice()
      // .domain([0, d3.max(this.series, d => d3.max(d, d => d[1]))]).nice()
      .range([this.height - this.margin.bottom, this.margin.top])
  }

  yAxis(g) {
    return g
      .attr("transform", `translate(${this.margin.left},0)`)
      .call(d3.axisLeft(this.y()))
      // .call(g => g.select(".domain").remove())
      // .call(g => g.select(".tick:last-of-type text")
      //   .clone()
      //   .attr("x", 3)
      //   .attr("text-anchor", "start")
      //   .attr("font-weight", "bold")
      //   .text(this.data.y))
  }

  line() {
    return d3.line()
      .defined(d => !isNaN(d.value))
      .x(d => this.x()(d.date))
      .y(d => this.y()(d.value))
      .curve(d3.curveMonotoneX)
  }

  area() {
    return d3.area()
      .x(d => this.x()(d.date))
      .y0(d => this.y()(d.value))
      .y1(this.y()(0))
      // .y0(d => this.y()(d[0]))
      // .y1(d => this.y()(d[1]))
      .curve(d3.curveMonotoneX)
  }

  colors() {
    // d3.schemeCategory10
    return d3.scaleOrdinal(this.datasets.map(dataset => dataset.id), this.colorsRange)
  }

  buildLegend(datasets) {
    const size = 10

    return this.legend
      .selectAll(".legend-item")
      .data(datasets)
      .join(
        enter => {
          const marginLeft = this.margin.left + 5
          const marginTop = this.margin.top - 5
          const marginBetween = 5
          const textWidth = 15
          const horizontal = true
          let x, y
          if (horizontal) {
            x = (d, i) => marginLeft + i * (size + textWidth + marginBetween * 2)
            y = () => marginTop
          } else {
            x = () => marginLeft
            y = (d, i) => marginTop + i * (size + marginBetween)
          }

          enter.append("rect")
            .attr('class', 'legend-item rect')
            .attr("x", x)
            .attr("y", y)
            .attr("width", size)
            .attr("height", size)
            .attr("fill", d => this.colors()(d.id))

          enter.append('text')
            .attr('class', 'legend-item-label text label')
            .attr("x", (d, i) => x(d, i) + size + marginBetween)
            .attr("y", (d, i) => y(d, i) + size / 2) // function(d,i){ return 100 + i*(size+5) + (size/2)}) // 100 is where the first dot appears. 25 is the distance between dots
            // .style("fill", function(d){ return color(d)})
            .attr('font-size', size)
            // .attr("height", size)
            .text(d => d.name)
            .attr("text-anchor", "left")
            .style("alignment-baseline", "middle")
          return enter
        },
        update => {
          update.select('rect')
            .attr("fill", d => this.colors()(d.id))
          
          update.select('text')
            .text(d => d.name)
            
        },
        exit => exit
          .remove()
      )
  }

  build() {
    // this.legendElement = this.svg.append("g")
    //   .attr("class", "legend")
    //   .attr("transform", "translate(20,20)")
    //   .call(this.buildLegend)

    // console.log('build.this', this)
    this.xAxisElement = this.svg.append("g")
      .call(this.xAxis.bind(this))
  
    this.yAxisElement = this.svg.append("g")
      .call(this.yAxis.bind(this))

    this.paths = this.svg.append('g')
      .attr('class', 'paths')

    this.legend = this.svg.append('g')
      .attr('class', 'legend')
      // .attr("transform", `translate(50%,0)`)

    // START: tooltip stuff
    this.tooltip = this.svg.append("g")
      .attr('class', 'tooltip')

    // this.svg.on("touchmove mousemove", () => this.mousemove(this.bisect()))
    this.svg.on("touchmove mousemove", this.mousemove(this.bisect()))
  
    this.svg.on("touchend mouseleave", () => this.tooltip.call(this.callout, null))
    // END: tooltip

    this.buildPaths(this.datasets)
    // this.datasets.forEach(dataset => {
    //   this.buildPath(dataset)
    // })

    this.buildLegend(this.datasets)

    return this.svg.node()
  }

  setSize(width, height) {
    this.width = width
    this.height = height
    
    this.svgElement.setAttribute('width', width)
    this.svgElement.setAttribute('height', height)
  }

  resize(width, height) {
    this.setSize(width, height)
    this.update(this.datasets)
  }

  update(datasets) {
    console.log('chart.update', datasets)

    // update the class's data prop
    this.datasets = datasets
    // console.log(this.datasets, this.datasets.columns)
    // if (datasets && datasets.length > 0) {
    //   console.log(this.datasets, this.datasets.columns)
    //   this.series = d3.stack().keys(this.datasets.columns.slice(1))(this.datasets)
    // } else {
    //   this.series = []
    // }

    // update the X axis:
    this.xAxisElement
      .transition()
      .duration(3000)
      .call(this.xAxis.bind(this))

    // update the Y axis
    this.yAxisElement
      .transition()
      .duration(3000)
      .call(this.yAxis.bind(this))

    // update paths
    this.buildPaths(datasets)

    // update legend
    this.buildLegend(datasets)
  }

  // buildPaths(datasets) {
  //   datasets.forEach(dataset => {
      
  //   })
  // }

  buildPaths(datasets) {
    const t = this.svg.transition()
      .duration(750);

    this.paths
      .selectAll('.line')
      .data(datasets)
      .join(
        enter => {
          enter.append("path")
            .attr('class', 'area')
            .attr('data-id', d => d.id)
            // fill
            .attr('fill', d => this.colors()(d.id))
            .attr('fill-opacity', this.fillOpacity)
            // stroke
            // .attr('stroke', d => this.colors()(d.id))
            .attr("stroke-width", 0)
            // .attr("stroke-linejoin", "round")
            // .attr("stroke-linecap", "round")
            .datum(d => d.data)
          .call(enter => enter.transition(t)
            // .attr('d', this.line()))
            .attr('d', this.area()))

          enter.append("path")
            .attr('class', 'line')
            .attr('data-id', d => d.id)
            // fill
            .attr('fill', 'none')
            // .attr('fill', d => this.colors()(d.id))
            // .attr('fill-opacity', 0.2)
            // stroke
            .attr('stroke', d => this.colors()(d.id))
            .attr("stroke-width", 1.5)
            .attr("stroke-linejoin", "round")
            .attr("stroke-linecap", "round")
            .datum(d => d.data)
          .call(enter => enter.transition(t)
            .attr('d', this.line()))
            // .attr('d', this.area()))
        },
        update => {
          // console.log(update)
          update
            .select('.line')
              .datum(d => d.data)
            .call(update => update.transition(t)
              .attr('d', this.line()))

          update
            .select('.area')
              .datum(d => d.data)
            .call(update => update.transition(t)
              // .attr('d', this.line()))
              .attr('d', this.area()))
        },
        exit => exit
            .attr("fill", "brown")
          .call(exit => exit.transition(t)
            .attr("y", 30)
            .remove())
      )
    
    
    // console.log(series)

    // this.paths
    //   .selectAll('.line')
    //   // .data(datasets)
    //   .data(series)
    //   .join(
    //     enter => {
    //       return enter.append("path")
    //         .attr('class', 'line')
    //         .attr('data-id', d => d.id)
    //         // .attr("fill", "none")
    //         .attr('fill', d => colors(d.id))
    //         .attr('fill-opacity', 0.2)
    //         // .attr("stroke", "steelblue")
    //         .attr('stroke', d => colors(d.id))
    //         .attr("stroke-width", 1.5)
    //         .attr("stroke-linejoin", "round")
    //         .attr("stroke-linecap", "round")
    //         .datum(d => d.data)
    //       .call(enter => enter.transition(t)
    //         // .attr('d', this.line()))
    //         .attr('d', this.area()))
    //     },
    //     update => update
    //         .datum(d => d.data)
    //       .call(update => update.transition(t)
    //         // .attr('d', this.line())),
    //         .attr('d', this.area())),
    //     exit => exit
    //         .attr("fill", "brown")
    //       .call(exit => exit.transition(t)
    //         .attr("y", 30)
    //         .remove())
    //   )
    
  }


  // buildPath(dataset) {
  //   const t = this.svg.transition()
  //     .duration(750);
  //   console.log(this)
  //   console.log('buildPath', dataset)
  //   console.log(this.svg)

  //   this.paths
  //     .selectAll(`.line[data-id="${dataset.id}"]`)
  //     // .selectAll('.line')
  //     // .data(dataset.data)
  //     .join(
  //       enter => {
  //         console.log('enter', enter, dataset, this.line(), dataset.data)
  //         return enter.append("path")
  //           .datum(dataset.data)
  //           .attr('class', 'line')
  //           .attr('data-id', dataset.id)
  //           .attr("fill", "none")
  //           .attr("stroke", "steelblue")
  //           .attr("stroke-width", 1.5)
  //           .attr("stroke-linejoin", "round")
  //           .attr("stroke-linecap", "round")
  //           // .attr('d', this.line())
  //         .call(enter => enter.transition(t)
  //           .attr('d', this.line()))
  //       },
  //       update => update
  //           .datum(dataset.data)
  //         .call(update => update.transition(t)
  //           .attr('d', this.line())),
  //       exit => exit
  //           .attr("fill", "brown")
  //         .call(exit => exit.transition(t)
  //           .attr("y", 30)
  //           .remove())
  //     );
  // }

  mousemove = (bisector) => (e) =>  {
    // const { date, value } = bisector(d3.mouse(this.svg.node())[0])
    const { date, value } = bisector(pointer(e)[0])

    // console.log('finding', date)
    const allData = this.datasets.map(ds => ds.data.find(d => d.date.getTime() == date.getTime()))
    // console.log(allData)

    // ${value.toLocaleString(undefined, {  })}
    this.tooltip
      .attr("transform", `translate(${this.x()(date)},${this.y()(value)})`)
      .call(this.callout, `
        ${date.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric" })}
        ${allData.map((item, i) => `${this.datasets[i].name}: ${item.value.toLocaleString(undefined, {  })}`).join('\n ')}
      `)
  }

  callout(g, value) {
    if (!value) return g.style("display", "none")
  
    g
      .style("display", null)
      .style("pointer-events", "none")
      .style("font", "10px sans-serif")
  
    const path = g.selectAll("path")
      .data([null])
      .join("path")
        .attr("fill", "white")
        .attr("stroke", "black");
  
    const text = g.selectAll("text")
      .data([null])
      .join("text")
      .call(text => text
        .selectAll("tspan")
        .data((value + "").split(/\n/))
        .join("tspan")
          .attr("x", 0)
          .attr("y", (_, i) => `${i * 1.1}em`)
          .style("font-weight", (_, i) => i ? null : "bold")
          .text(d => d));
  
    const { y, width: w, height: h } = text.node().getBBox();
  
    text.attr("transform", `translate(${-w / 2},${15 - y})`);
    path.attr("d", `M${-w / 2 - 10},5H-5l5,-5l5,5H${w / 2 + 10}v${h + 20}h-${w + 20}z`);
  }

  bisect() {
    const datasetIndex = this.datasets.length - 1
    const bisect = d3.bisector(d => d.date).left;
    const data = this.datasets[datasetIndex].data
    return mx => {
      const date = this.x().invert(mx);
      const index = bisect(data, date, 1);
      const a = data[index - 1];
      const b = data[index];
      // console.log('a', a)
      // console.log('b', b)
      if (b === undefined) return a
      return date - a.date > b.date - date ? b : a;
    };
  }
}

export { LineChart }